import { useAuth } from "../hooks/useAuth";
import { useConnectivity } from "../hooks/useConnectivity";
import LoadingScreen from "../components/common/LoadingScreen";
import OfflineRecoveryScreen from "../components/common/OfflineRecoveryScreen";
import { isFirebaseConfigReady } from "../config/firebaseConfig";

/**
 * Waits for the first Firebase auth state check (signed in or not).
 * When offline, never leave a blank white root — show TRA offline recovery.
 */
export default function AuthBootstrap({ children }) {
  const { loading, error } = useAuth();
  const { online } = useConnectivity();

  if (!isFirebaseConfigReady()) {
    return (
      <LoadingScreen message="This build isn’t configured yet. An operator needs to set the cloud environment variables, then rebuild and redeploy." />
    );
  }

  if (!online && (loading || error)) {
    return <OfflineRecoveryScreen />;
  }

  if (loading) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <LoadingScreen
        message={
          error.message ||
          "Could not connect. Check that Google and Email/Password sign-in are enabled, then refresh."
        }
      />
    );
  }

  return children;
}
